import type { ManualSection } from '../manual.types';

export const auditoriaSection: ManualSection = {
  slug: 'auditoria',
  title: 'Auditoría',
  icon: 'ki-shield-search',
  summary: 'Quién cambió qué y cuándo, con el antes y el después de cada cambio.',
  audience: 'Administradores.',
  topics: [
    {
      id: 'que-registra',
      title: 'Qué se registra y qué no',
      blocks: [
        {
          kind: 'p',
          text: 'Cada registro guarda **quién**, **qué acción**, **sobre qué entidad**, **cuándo** y **con qué resultado**. Los cambios traen además el estado anterior y el nuevo.'
        },
        {
          kind: 'table',
          head: ['Se registra', 'Acciones'],
          rows: [
            [
              '**Autenticación**',
              'Entradas exitosas y fallidas, salidas, cambio de contraseña, solicitud y consumo de reseteo'
            ],
            ['**Usuarios**', 'Alta, edición, baja'],
            ['**CPD**', 'Templates, Operators, Routes y Overrides: alta, edición, baja y recargas']
          ]
        },
        {
          kind: 'note',
          tone: 'warn',
          title: 'Todavía no se registran Salientes, Entrantes ni Dialplan',
          text: 'Es un pendiente conocido del backend. Un cambio en esas tres pantallas **no** deja rastro en Auditoría. Si estás validando trazabilidad, tenlo presente.'
        },
        { kind: 'p', text: 'La retención es de **365 días**.' }
      ]
    },
    {
      id: 'como-usarla',
      title: 'Cómo usar la pantalla',
      blocks: [
        {
          kind: 'kv',
          items: [
            { k: 'Rango de fechas', v: 'Obligatorio.' },
            { k: 'Entidad', v: 'Autenticación, usuario, o cada uno de los tipos de CPD.' },
            { k: 'Acción', v: 'Alta, edición, baja, recarga, entrada, salida, contraseña…' },
            { k: 'Resultado', v: 'Si la operación tuvo éxito o falló.' },
            { k: 'Actor', v: 'El identificador de quien hizo el cambio.' },
            { k: 'Entidad afectada', v: 'El identificador del registro tocado.' }
          ]
        },
        {
          kind: 'p',
          text: 'La tabla pagina en el servidor. Al **abrir una fila** se ve el detalle: el diff entre el estado anterior y el nuevo, más los metadatos de la petición.'
        },
        {
          kind: 'h4',
          text: 'La columna "Quién"'
        },
        {
          kind: 'ul',
          items: [
            'Para una sesión autenticada muestra usuario, rol y correo.',
            'Para un **intento de entrada fallido** muestra "intento: *usuario*", porque nadie llegó a autenticarse: se guarda el identificador que se intentó usar.'
          ]
        },
        {
          kind: 'note',
          tone: 'info',
          title: 'Si ves registros viejos sin nombre',
          text: 'Los datos de identidad se empezaron a guardar a partir de una corrección reciente. Los registros anteriores conservan solo el identificador interno y no se pueden completar hacia atrás. Además, después de esa corrección hay que **volver a iniciar sesión** para que el nombre aparezca: las sesiones abiertas de antes no lo traen.'
        }
      ]
    }
  ]
};
